<template>
  <el-popover
    placement="bottom"
    v-model="visible"
    :disabled="!showButton"
  >
    <component
      :is="config.componentType"
      size="mini"
      v-bind="config"
      v-model="data"
      :props="config.props"
    ></component>
    <div class="btns">
      <el-button
        size="mini"
        type="text"
        @click="visible = false"
      >取消</el-button>
      <el-button
        type="primary"
        size="mini"
        @click="confirm"
      >确定</el-button>
    </div>

    <div
      slot="reference"
      class="edit-text"
      :style="[style]"
    >
      <default-text
        @stopClick="defaultClick"
        :table-data="tableData"
        :scope="scope"
      ></default-text>
      <ig-icon
        class="icon"
        name="brush"
        v-show="showButton"
      ></ig-icon>
    </div>
  </el-popover>
</template>
<script>
import defaultText from '@/components/iglobalwin/dataList/defaultText'
import userSearch from '@/components/tools/userSearch'
import formComponent from '@/components/iglobalwin/formComponents/index.js'
export default {
  name: 'edit_text',
  components: {
    defaultText,
    userSearch,
    ...formComponent,
  },
  props: {
    tableData: Object,
    scope: Object,
    triggerEvent: {
      required: false,
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: '',
    }
  },
  computed: {
    showButton() {
      if (this.tableData.showButton) {
        return this.tableData.showButton(this.scope.row)
      } else {
        return true
      }
    },
    style() {
      return this.tableData.style || ''
    },
    config() {
      let { tableData, scope } = this
      if (typeof tableData.config == 'function') {
        return tableData.config(scope.row)
      } else {
        return tableData.config
      }
    },
  },
  methods: {
    confirm() {
      this.loading = true
      this.tableData.triggerEvent &&
        this.tableData.triggerEvent(this.scope.row, this.data, () => {
          this.visible = false
          this.loading = false
          this.data = ''
        })
    },
    defaultClick() {
      this.tableData.defaultClick &&
        this.tableData.defaultClick(this.scope.row, this.data)
    },
  },
}
</script>
<style lang="scss" scoped>
.btns {
  text-align: right;
  margin-top: 10px;
  border-top: 1px solid rgb(238, 238, 238);
  padding-top: 10px;
}
.edit-text {
  display: flex;
  .icon {
    display: none;
    margin-left: 10px;
  }
  &:hover {
    .icon {
      color: #999;
      /*font-size: 14px;*/
      display: inline-block;
      cursor: pointer;
      margin-left: 10px;
      &:hover {
        color: #54a8fe;
      }
    }
  }
}
</style>
